import { Tags } from "lucide-react";
import { BridgeReadOnly } from "@/components/common/BridgeReadOnly";

export default function Kategorien() {
  return (
    <BridgeReadOnly
      resource="kategorien"
      title="Kategorien"
      subtitle="Kategorien und Sortimentsstruktur – read-only via FUNDIO Bridge (Directorist ist Master)."
      icon={Tags}
      columns={[
        { key: "name", label: "Kategorie" },
        { key: "slug", label: "Slug" },
        { key: "count", label: "Anzahl" },
      ]}
    />
  );
}
